export default __webpack_public_path__ + "static/media/record-stop-button.ce9ceb4a.svg";